// eslint-disable-next-line
import Apis from '@/Apis/_'
import ResponseApi from '../interfaces/FactoryResponse'
import { CoreBase, ICoreBase } from './CoreBase'

class Suprimentos extends CoreBase implements ISuprimentos {
  async backofficeSuprimentosAvaliaMaterial(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.backofficeSuprimentosAvaliaMaterial(params)
    return response
  }

  async backofficeSuprimentosAtualizaPrecificacaoOperadora(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.backofficeSuprimentosAtualizaPrecificacaoOperadora(params)
    return response
  }

  async backofficeSuprimentosConfirmaReservaDeMateriais(solicitacaoId: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.backofficeSuprimentosConfirmaReservaDeMateriais(solicitacaoId)
    return response
  }
}

interface ISuprimentos extends ICoreBase {
  backofficeSuprimentosAvaliaMaterial(params: any): Promise<ResponseApi>
  backofficeSuprimentosAtualizaPrecificacaoOperadora(params: any): Promise<ResponseApi>
  backofficeSuprimentosConfirmaReservaDeMateriais(solicitacaoId: string): Promise<ResponseApi>
}

export {
  Suprimentos,
  ISuprimentos,
}
